import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    // Check if admin credentials are stored in sessionStorage
    const storedAuth = sessionStorage.getItem('admin_auth');
    if (storedAuth) {
      const auth = JSON.parse(storedAuth);
      setCredentials(auth);
      setIsAuthenticated(true);
    }
  }, []);

  const login = (password) => {
    // Create basic auth credentials
    const auth = {
      username: 'admin',
      password: password,
      basicAuth: btoa(`admin:${password}`)
    };
    
    sessionStorage.setItem('admin_auth', JSON.stringify(auth));
    setCredentials(auth);
    setIsAuthenticated(true);
    return true;
  };

  const logout = () => {
    sessionStorage.removeItem('admin_auth');
    setCredentials(null);
    setIsAuthenticated(false);
  };

  const getAuthHeaders = () => {
    if (!credentials) return {};
    return {
      'Authorization': `Basic ${credentials.basicAuth}`
    };
  };

  return (
    <AdminContext.Provider value={{ 
      isAuthenticated, 
      login, 
      logout, 
      getAuthHeaders,
      credentials
    }}>
      {children}
    </AdminContext.Provider>
  );
};
